<template>
  <div class="">
    <hr>
    <div class="my-2">
      <span class="badge badge-pill mx-2 badge-warning text-capitalize">{{ item.type }}</span>
      <span class="badge badge-pill mx-2 badge-warning text-capitalize">شناسه: {{ item.id }}</span>
      <div class="form-group d-inline-block">
        <input :id="`secure-${item.id}`" type="checkbox" v-model="item.security">
        <label :for="`secure-${item.id}`" class="mx-2 d-inline-block">محافظت شده</label>
      </div>
    </div>
    <div class="">
      <div class="form-group">
        <input v-model="item.config['only_admin_edit']" :id="`admin_edit_${item.id}`" type="checkbox">
        <label :for="`admin_edit_${item.id}`" class="mx-2">اصلاح توسط ادمین</label>
      </div>

      <div class="form-group">
        <input v-model="item.config['format_number']" :id="`format_number${item.id}`" type="checkbox">
        <label :for="`format_number${item.id}`" class="mx-2">جداسازی اعداد</label>
      </div>

    </div>
    <div class="form-group">
      <input type="text" class="mb-2 form-control" v-model="item.title">
      <input type="text" class="mb-2 form-control" placeholder="پترن" v-model="item.config.pattern">
      <textarea disabled class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
    </div>
    <b-icon class="bg-danger d-inline p-1 rounded-pill mx-2 h3 text-white  my-2" icon="trash"
            @click="deleteQuestion()"/>
  </div>
</template>

<script>
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";

export default {
  name: "TextareaInput",
  props: {
    item: {}
  },
  computed: {
    generateHashComputed() {
      return generateHash()
    }
  },
  methods: {
    deleteQuestion() {
      this.$emit('removeQuestion')
    }
  }
}
</script>

<style scoped>

</style>